import { Button } from "@/Button";
import { LayoutHeader } from "@/Header";
import { ValidateSelectBoxImg } from "@/SelectBoxImg";
// import { ValidateSelectList } from "@/SelectList";
import { ValidateTextarea } from "@/Textarea";
import { Dialog } from "@/Dialog";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import useNoticeSend from "^/customer/noticeSend";
import { Controller, useForm } from "react-hook-form";
import { useUserNoticeSend } from "~/services/customer/notice";
import { useState } from "react";

interface SendFixParams {
  companySeq: string;
  companyName: string;
}

interface InformSendState {
  recipient: string;
  animal: string[]; // 배열로 변경하여 다중 선택 지원
  content: string;
}
export const Route = createFileRoute("/customer/layout/inform-send-fix")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): SendFixParams => {
    return {
      companySeq: search.companySeq as string,
      companyName: search.companyName as string,
    };
  },
});

function RouteComponent() {
  const { history } = useRouter();
  const { companySeq, companyName } = Route.useSearch();
  const {
    handleSubmit,
    control,
    formState: { isValid },
    // watch,
  } = useForm<InformSendState>({
    defaultValues: {
      recipient: companySeq,
      animal: [], // 빈 배열로 초기화
      content: "",
    },
    mode: "onChange",
  });

  // Dialog 상태 관리
  const [isSuccessDialogVisible, setIsSuccessDialogVisible] = useState(false);
  const [isErrorDialogVisible, setIsErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { noticeSendSubData } = useNoticeSend();
  console.log(noticeSendSubData);

  // noticeSendSubData를 사용하여 수신자 옵션 생성 (중복 제거)
  // const ownerOptions =
  //   noticeSendSubData?.companyList
  //     ?.filter(
  //       (company: any, index: number, self: any[]) =>
  //         index ===
  //         self.findIndex((c: any) => c.companySeq === company.companySeq)
  //     )
  //     ?.map((company: any) => ({
  //       value: company.companySeq.toString(),
  //       label: company.companyName,
  //     })) || [];

  // noticeSendSubData를 사용하여 반려동물 옵션 생성
  const petOptions = noticeSendSubData?.pets?.map((pet: any) => ({
    label: pet.petName,
    value: pet.petSeq.toString(),
    imgSrc: pet.fileUrl,
  })) || [
    {
      label: "유치원",
      value: "유치원",
      imgSrc: "/images/pet-img.png",
    },
    {
      label: "데이케어",
      value: "데이케어",
      imgSrc: "/images/pet-img.png",
    },
    {
      label: "호텔링",
      value: "호텔링",
      imgSrc: "/images/pet-img.png",
    },
    {
      label: "어질리티",
      value: "어질리티",
      imgSrc: "/images/pet-img.png",
    },
    {
      label: "행동교정",
      value: "행동교정",
      imgSrc: "/images/pet-img.png",
    },
    {
      label: "전문훈련",
      value: "전문훈련",
      imgSrc: "/images/pet-img.png",
    },
    {
      label: "미용",
      value: "미용",
      imgSrc: "/images/pet-img.png",
    },
    {
      label: "목욕",
      value: "목욕",
      imgSrc: "/images/pet-img.png",
    },
  ];
  // console.log(watch());
  const { mutate: sendNotice, isPending } = useUserNoticeSend();

  const bindSubmit = (data: InformSendState) => {
    console.log(data);

    // 선택된 반려동물들의 petSeq 추출 (배열)
    const selectedPetSeqs = data.animal.map((petSeq) => parseInt(petSeq));

    const requestData = {
      companySeq: parseInt(data.recipient),
      petSeqs: selectedPetSeqs,
      notiContents: data.content,
    };

    sendNotice(requestData, {
      onSuccess: (response) => {
        console.log("알림 전송 성공:", response);
        setIsSuccessDialogVisible(true);
      },
      onError: (error) => {
        console.error("알림 전송 실패:", error);
        setErrorMessage("알림 전송에 실패했습니다.");
        setIsErrorDialogVisible(true);
      },
    });
  };

  // 성공 Dialog 핸들러
  const handleSuccessDialogClose = () => {
    setIsSuccessDialogVisible(false);
    history.push("/customer/layout/inform?tab=sent");
  };

  // 에러 Dialog 핸들러
  const handleErrorDialogClose = () => {
    setIsErrorDialogVisible(false);
  };

  return (
    <>
      <LayoutHeader title={"알림장 보내기"} hasBackBtn hasFootPrint={false} />
      {/* 수신자 */}
      <div className="flex flex-col flex-1 min-h-0 overflow-y-auto">
        <form className="flex-col flex-auto gap-1 px-5 pt-5 pb-12 bg-[#F5F5F5] grid grid-cols-1">
          <div className="mb-5">
            <div className="flex items-center">
              <div className="font-medium text-gray-500">수신자 :</div>
              <div className="ml-2 text-lg font-semibold">{companyName}</div>
            </div>
            {/* <Controller
              name="recipient"
              control={control}
              rules={{ required: "필수 선택입니다." }}
              render={({ field }) => (
                <ValidateSelectList
                  onChange={(selectedOption) =>
                    field.onChange(selectedOption?.value || "")
                  }
                  label="수신자"
                  placeholder="위탁사업자 이름"
                  options={ownerOptions}
                  value={
                    field.value
                      ? ownerOptions.find(
                          (option: any) => option.value === field.value
                        )
                      : null
                  }
                />
              )}
            /> */}
            <div className="my-5">
              <Controller
                name="animal"
                control={control}
                rules={{ required: "필수 선택입니다." }}
                render={({ field }) => (
                  <ValidateSelectBoxImg
                    label="반려동물 선택"
                    required={true}
                    max={1} // 최대 5개까지 선택 가능
                    {...field}
                    options={petOptions}
                  />
                )}
              />
            </div>
            <div className="mt-10">
              <Controller
                name="content"
                control={control}
                rules={{ required: "필수 선택입니다." }}
                render={({ field }) => (
                  <ValidateTextarea
                    {...field}
                    className="w-full h-100"
                    label="내용"
                    rows={10}
                    // value={info?.name}
                  />
                )}
              />
            </div>
          </div>
        </form>
        <div className="sticky bottom-14 w-full px-5 py-3 bg-[#F5F5F5]">
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleSubmit(bindSubmit)}
            disabled={!isValid || isPending}
          >
            <div className="py-3 mx-auto w-full text-base font-semibold text-center text-white bg-orange-400 rounded-full">
              발송
            </div>
          </Button>
        </div>
      </div>

      {/* 성공 Dialog */}
      <Dialog
        visible={isSuccessDialogVisible}
        onClose={handleSuccessDialogClose}
        persist={false}
      >
        <div className="flex flex-col gap-1">
          <div className="flex flex-col mb-2">
            <div className="text-lg font-semibold text-center">발송 완료</div>
          </div>
          <div className="flex flex-col mb-2">
            <div className="text-sm text-center text-[#666666]">
              알림이 성공적으로 전송되었습니다.
            </div>
          </div>
          <div className="flex gap-3 mt-2">
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={handleSuccessDialogClose}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 에러 Dialog */}
      <Dialog
        visible={isErrorDialogVisible}
        onClose={handleErrorDialogClose}
        persist={false}
      >
        <div className="flex flex-col gap-1">
          <div className="flex flex-col mb-2">
            <div className="text-lg font-semibold text-center">발송 실패</div>
          </div>
          <div className="flex flex-col mb-2">
            <div className="text-sm text-center text-[#666666]">
              {errorMessage}
            </div>
          </div>
          <div className="flex gap-3 mt-2">
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={handleErrorDialogClose}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
}
